/* eslint-disable import/prefer-default-export */
export const calculateUsedPercentage = (total: string, remaining: string): number => {
  const usage = parseFloat(total) - parseFloat(remaining)
  const percent = (usage / parseFloat(total)) * 100
  return percent
}
